import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AuthActions, AuthSelectors } from '../../modules/auth'
import { Grid, Segment, Form, Message } from 'semantic-ui-react'
import Token from '../../helpers/token'

import { AnalyticsActions } from '../../modules/analytics';
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_SITE_KEY, BASE_URL } from '../../constants/constants';
import "./style.css";
import axios from "axios";
const { selectDate } = AnalyticsActions;

const { getSelectorAuth } = AuthSelectors;
const { authOnLogin, authOnChange, authOnLogout } = AuthActions;

class Login extends Component {


    captcha = React.createRef();

    state = {
        showCaptcha: false,
        captcha: null

    }


    onLogin() {
        const { email, password, captchaVal, authOnLogin } = this.props

        // console.log("Hello", this.state.captchaVal)
        // const captchaVal = this.state.captchaVal

        console.log("Second is: ", captchaVal)
        authOnLogin({ email, password, captchaVal })
    }

    onChangeEmail(e) {
        this.props.authOnChange('email', e.target.value)
    }

    onChangePassword(e) {
        this.props.authOnChange('password', e.target.value)
    }



    componentDidUpdate() {
        if (this.props.errors && this.props.errors.length && this.props.captchaVal === '') {
            this.captcha.current.reset()
        }
    }

    render() {
        return (
            <Grid padded={true} columns='equal' className="loginContainer" style={styles.container} verticalAlign='middle' textAlign='center'>
                <Grid.Column>
                </Grid.Column>

                <Grid.Column width={6}>
                    <div style={styles.logoMain}>
                        <img src="logo.png" />
                    </div>

                    <h1 className="ui title image header" style={styles.title}>
                        <div style={styles.loginTitle} className="content">
                            Analytics Dashboard
                        </div>
                    </h1>

                    <Form onSubmit={this.onLogin.bind(this)} error={this.props.errors.length != 0}>
                        <Form.Input placeholder='Email' name='email' value={this.props.email} onChange={this.onChangeEmail.bind(this)} />
                        <Form.Input type='password' placeholder='Password' name='password' value={this.props.password} onChange={this.onChangePassword.bind(this)} />
                        <Message style={styles.message} error>
                            The email or password you entered is incorrect. Please try again.
                        </Message>
                        {this.props.captchaVal ?
                            <Form.Button floated='right' style={styles.loginButton} content='Login' loading={this.props.loading} />
                            :
                            null
                        }
                        {/* <Form.Button floated='right' style={styles.loginButton} content='Login' loading={this.props.loading} /> */}
                    </Form>


                    <ReCAPTCHA
                        ref={this.captcha}
                        sitekey={RECAPTCHA_SITE_KEY}
                        onChange={(value) => this.props.authOnChange('captchaVal', value)}
                        badge='inline'
                    />

                </Grid.Column>
                <Grid.Column>
                </Grid.Column>
            </Grid>
        )
    }
}


const styles = {
    container: {
        // backgroundImage: 'url(background.png)',
        // backgroundImage: linear-gradient(#776cd3 ,#d35ffb),
        // backgroundSize: 'cover',
        // color: 'white',
        // height: '100%'
    },
    logoMain: {
        marginTop: -20,
    },
    loginTitle: {
        fontFamily: 'Roboto',
        fontWeight: 300,
        fontSize: 30,
    },
    loginButton: {
        textAlign: 'right',
    },
    loginButton: {
    },
    btn: {
        background: 'rgba(136,164,255,.9)',
        color: 'white',
        fontSize: '12px',
        width: '100%',
        border: 0,
        borderRadius: '4px'
    },
    title: {
        color: 'white'
    },
    message: {
        color: '#fff',
        background: 'transparent',
        boxShadow: '0 0 0 0',
        fontFamily: 'Roboto',
        fontWeight: 300,

    }
}

const mapStateToProps = state => {
    return getSelectorAuth(state)
}

export default connect(mapStateToProps, { authOnLogin, authOnChange, authOnLogout })(Login)



// WEBPACK FOOTER //
// ./src/containers/Login/index.js